module.exports = __webpack_public_path__ + "img/c2.02e479e7.png";